import React, { useEffect, useState } from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import api from "../lib/api";
import { fmt } from "../lib/format";

const Net = ({ v, testId, size = "text-sm" }) => {
  const up = v >= 0;
  return <div className={`${size} font-black flex items-center justify-center gap-0.5 ${up ? "text-emerald-600" : "text-red-500"}`} data-testid={testId}>{up ? <TrendingUp className="w-3.5 h-3.5" /> : <TrendingDown className="w-3.5 h-3.5" />}{up ? "+" : "-"}{fmt(Math.abs(v))}</div>;
};

const DAY = ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"];
const WeekBars = ({ days }) => {
  const max = Math.max(1, ...days.map((d) => Math.abs(d.net)));
  return (
    <div className="flex items-end justify-between gap-1 h-12 mt-2" data-testid="week-bars">
      {days.map((d, i) => {
        const h = Math.max(3, Math.round((Math.abs(d.net) / max) * 36));
        const idle = !d.bet && !d.won;
        return (
          <div key={d.date} className="flex-1 flex flex-col items-center justify-end gap-0.5" title={`${d.date} · bet ${fmt(d.bet)} · won ${fmt(d.won)}`} data-testid={`week-bar-${d.date}`}>
            <div className={`w-full max-w-[22px] rounded-t-sm ${idle ? "bg-slate-200" : d.net >= 0 ? "bg-emerald-500" : "bg-red-400"}`} style={{ height: idle ? 3 : h }} />
            <span className={`text-[9px] font-bold ${i === days.length - 1 ? "text-slate-900" : "text-slate-400"}`}>{DAY[new Date(d.date).getDay()]}</span>
          </div>
        );
      })}
    </div>
  );
};

/* Today's + this week's bet / won / net for the logged-in customer (IST days). */
export const TodaySummaryStrip = ({ ta, refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/bets/today-summary").then((r) => setS(r.data)).catch(() => {}); }, [refreshKey]);
  if (!s) return null;
  const wk = s.week || { bet: 0, won: 0, net: 0, days: [] };
  if (!s.bet && !s.won && !wk.bet && !wk.won) return null;
  return (
    <div className="rl-card p-3" data-testid="today-summary-strip">
      <div className="grid grid-cols-3 divide-x divide-slate-100">
        <div className="px-1 text-center"><div className="text-[10px] font-bold text-slate-500">{ta ? "இன்று பந்தயம்" : "Today bet"}</div><div className="text-sm font-black text-slate-900" data-testid="today-summary-bet">{fmt(s.bet)}</div><div className="text-[10px] text-slate-400">{s.tickets} {ta ? "டிக்கெட்" : "tickets"}</div></div>
        <div className="px-1 text-center"><div className="text-[10px] font-bold text-slate-500">{ta ? "இன்று வெற்றி" : "Today won"}</div><div className="text-sm font-black text-emerald-600" data-testid="today-summary-won">{fmt(s.won)}</div><div className="text-[10px] text-slate-400">{s.pending ? `${s.pending} ${ta ? "காத்திருப்பு" : "pending"}` : "—"}</div></div>
        <div className="px-1 text-center"><div className="text-[10px] font-bold text-slate-500">{ta ? "நிகரம்" : "Net"}</div><Net v={s.net} testId="today-summary-net" /></div>
      </div>
      <div className="mt-3 pt-2 border-t border-dashed border-slate-200" data-testid="week-summary">
        <div className="flex items-center justify-between text-[11px]">
          <span className="font-black text-slate-700">{ta ? "இந்த வாரம்" : "This week"}</span>
          <span className="text-slate-500">{ta ? "பந்தயம்" : "Bet"} <b className="text-slate-900" data-testid="week-summary-bet">{fmt(wk.bet)}</b> · {ta ? "வெற்றி" : "Won"} <b className="text-emerald-600" data-testid="week-summary-won">{fmt(wk.won)}</b></span>
          <Net v={wk.net} testId="week-summary-net" size="text-xs" />
        </div>
        {wk.days?.length > 0 && <WeekBars days={wk.days} />}
      </div>
    </div>
  );
};
